import { useNavigate } from 'react-router-dom';
import { API, Auth, graphqlOperation } from 'aws-amplify';
import { showSuccessSnackbar, showWarningSnackbar } from '../../snackBar/snakbar';
import { useEffect, useRef, useState } from 'react';
import { invokeIfCallable } from '../../../library/shared';
import axios from 'axios';
import { logOut } from '../../../redux/reducers/login';
import { logOutStop, logoutStart } from '../../../redux/reducers/logout';
import { logoutCognitoUser } from '../../../graphql/mutations';
import { useDispatch } from 'react-redux';
import { skipReset } from '../../../redux/reducers/companySkipSave';
import { persistor } from '../../../redux/store';
import API_ENDPOINTS from '../../../apiEndpoints';
import { isValidPassword } from '../../../utils/Regex';

export const useChangePassword = ({ open, onClose }) => {
  const [backDrop, setBackDrop] = useState(false);
  const initialState = {
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
    errorFields: {
      currentPassword: '',
      newPassword: '',
      confirmPassword: '',
    },
    errorStatus: {
      currentPassword: false,
      newPassword: false,
      confirmPassword: false,
    },
  };
  const reset = () => {
    setData(initialState);
  };
  const [data, setData] = useState(initialState);
  const [loading, setLoading] = useState(false);
  const handleChange = (e, FormatedName) => {
    const name = e.target.name;

    let value = e.target.value?.trim();
    if (value == '') {
      setData((prev) => ({
        ...prev,
        [name]: value,
        errorFields: {
          ...prev.errorFields,
          [name]: `${FormatedName} is required`,
        },
        errorStatus: {
          ...prev.errorStatus,
          [name]: true,
        },
      }));
    } else {
      setData((prev) => ({
        ...prev,
        [name]: value,
        errorFields: {
          ...prev.errorFields,
          [name]: '',
        },
        errorStatus: {
          ...prev.errorStatus,
          [name]: false,
        },
      }));
    }
  };
  const validation = async () => {
    try {
      let isvalid = true;
      Object.keys(data).map((itemKey) => {
        if (itemKey === 'currentPassword') {
          if (data[itemKey].trim().length <= 0) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: true,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: 'Current Password is required',
              },
            }));
          } else if (data[itemKey].trim().length < 8) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: true,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: 'Current Password is Invalid',
              },
            }));
          } else {
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: false,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: '',
              },
            }));
          }
        }
        if (itemKey === 'newPassword') {
          if (data[itemKey].trim().length <= 0) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: true,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: 'Password is required',
              },
            }));
          } else if (!isValidPassword(data[itemKey])) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: true,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: '',
                // "Password Requires atleast one lowercase and uppercase letters,numbers and special characters, Whitespace not allowed and Minimum 8 characters, maximum 99 characters",
              },
            }));
          } else if (data[itemKey] === data['currentPassword']) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: false,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: 'Current Password and New Password Cannot Be Same !',
              },
            }));
          } else {
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: false,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: '',
              },
            }));
          }
        }

        if (itemKey === 'confirmPassword') {
          if (data[itemKey].trim().length <= 0) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: true,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: 'Confirm Password is required',
              },
            }));
          } else if (data['newPassword'] !== data[itemKey]) {
            isvalid = false;
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: true,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: 'Password not matching',
              },
            }));
          } else {
            setData((prev) => ({
              ...prev,
              errorStatus: {
                ...prev.errorStatus,
                [itemKey]: false,
              },
              errorFields: {
                ...prev.errorFields,
                [itemKey]: '',
              },
            }));
          }
        }
      });

      return isvalid;
    } catch (error) {
      console.log(error);
    }
  };
  // const handleMobileMenuClose = () => {
  //     setMobileMoreAnchorEl(null);
  // };

  // const handleMenuClose = () => {
  //     setAnchorEl(null);
  //     handleMobileMenuClose();
  // };
  const sessionTimeoutRef = useRef(null);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const handleSignout = async () => {
   return navigate('/signout', { replace: true });
    let accessToken = null;
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);

      if (key.startsWith('CognitoIdentityServiceProvider') && key.endsWith('.accessToken')) {
        accessToken = localStorage.getItem(key);
        break;
      }
    }

    try {
      setBackDrop(true);
      if (accessToken) {
        const option = {
          method: 'POST',
          url: API_ENDPOINTS.REACT_APP_GLOBAL_SIGNOUT_URL,
          headers: { Authorization: accessToken },
        };
        await axios(option);
      }
      let sessions = await API.graphql(graphqlOperation(logoutCognitoUser));
      dispatch(skipReset());
      dispatch(logoutStart());

      // handleMenuClose();
      clearTimeout(sessionTimeoutRef.current);
      localStorage.clear();
      const cookies = document.cookie.split(';');
      for (let i = 0; i < cookies.length; i++) {
        const cookie = cookies[i];
        const eqPos = cookie.indexOf('=');
        const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
        document.cookie = name + '=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=/';
      }
      await Auth.signOut();
      localStorage.clear();
      persistor.purge(); // purge redux
      dispatch(logOut());
      // Hub.dispatch('auth', { payload: { event: 'oAuthSignOut' } });
      dispatch(logOutStop());
      localStorage.removeItem('emailID');
      localStorage.removeItem('mobileNo');
      // window.location.reload()
    } catch (error) {
      console.log(error);
      await Auth.signOut();
      dispatch(logOut());
      dispatch(logOutStop());
      window.location.reload();
    } finally {
      setBackDrop(false);
    }
  };
  async function changePassword() {
    try {
      const { currentPassword, newPassword } = data;
      setLoading(true);
      if (await validation()) {
        const user = await Auth.currentAuthenticatedUser();
        await Auth.changePassword(user, currentPassword, newPassword);
        showSuccessSnackbar('Password Updated');
        handleSignout();
        invokeIfCallable(onClose);
      }
    } catch (err) {
      console.log(err.code);
      if (err?.code === 'LimitExceededException') {
        showWarningSnackbar(err.message);
        invokeIfCallable(onClose, 1000);
      } else if (err?.code === 'NotAuthorizedException') {
        showWarningSnackbar('Current Password is not correct !');
      } else if (err?.code === 'PasswordHistoryPolicyViolationException') {
        showWarningSnackbar('Password reuse detected. Please choose a different password.');
      } else {
        showWarningSnackbar('Something Went wrong !');
      }
    } finally {
      setLoading(false);
    }
  }
  useEffect(() => {
    if (!open) reset();
    return () => {
      reset();
    };
  }, [open]);
  return { data, handleChange, changePassword, reset, loading, backDrop };
};
